import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const CartProductMeta: FunctionComponent<TParentComponentProps> = (
  props
) => {
  return <ParentComponent {...props} />;
};

CartProductMeta.defaultProps = {
  defaultClassName: 'cart-product__meta',
  as: 'div',
};

export default CartProductMeta;
